export default function getPriceBasedOnDiscount(promocode, totalPriceAfterDiscount, totalPrice) {
  return promocode ? totalPriceAfterDiscount : totalPrice;
}